/* !
 * setting.js v1.0.0
 * Copyright, Connecty Inc.
 */
const siteName = 'default-package';
const htmlHasClass = (_class) => { return document.documentElement.classList.contains(_class); };
const a = 'is-active';
const v = 'is-visible';
const f = 'is-fixed';

window.FUNCTIONS = {
	va: {
		pathname: location.pathname,
		isMobile: htmlHasClass('ua-mobile'),
		device: {
			desktop: 1024,
			sp: 768
		},
		window: {
			width: window.innerWidth,
			height: window.innerHeight
		},
		header: {
			desktop: 110,
			sp: 46
		}
	},
	localDecision() {
		const regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.|100\\.64\\.)`, 'g');
		return regExp.test(location.hostname);
	},
	localLoading() { // ローカル環境ならincludeをAjaxで読み込む
		const _this = this;
		const key = 'inc_';
		let ajaxArray = [];
		let ajaxArrayList = [];
		let includeClass = document.querySelectorAll(`[class*="${key}"]`);

		includeClass.forEach(ele => {
			let path = ele.innerHTML.split(' ')[1];
			ajaxArray.push(path);
		});

		if (ajaxArray.length) {
			ajaxArray.forEach(ele => {
				let xhr = new XMLHttpRequest();
				let promise = new Promise((resolve, reject) => {
					xhr.onreadystatechange = function () {
						if (xhr.readyState === 4) {
							if (xhr.status === 200) {
								resolve(xhr.responseText);
							} else {
								reject(xhr.statusText);
							}
						}
					};
				});
				xhr.open('GET', ele + '.html', true);
				xhr.send();
				ajaxArrayList.push(promise);
			});

			Promise.all(ajaxArrayList).then(results => {
				let regExp = new RegExp(key);

				results.forEach(ele => {
					let classList = ele.split(/ |\"/g);
					let position;

					classList.forEach(ele2 => {
						if (ele2.match(regExp)) { position = ele2; }
					});
					document.querySelectorAll('.' + position).forEach(ele2 => {
						ele2.outerHTML = ele;
					});
					console.log('Succeeded to read the include file!:', position);
				});

				// 置換完了時にカスタムイベントを発火
				document.dispatchEvent(new Event('localincludeLoaded'));

				_this.loadDelayScript();
			}).catch((error) => {
				console.error('Failed to read the include file:', error);

				document.dispatchEvent(new Event('localincludeLoaded'));
				_this.loadDelayScript();
			});
		} else {
			document.dispatchEvent(new Event('localincludeLoaded'));
			_this.loadDelayScript();
		}
	},
	getQuery() {
		let vars = [];
		let hash = null;
		let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		hashes.forEach(ele => {
			hash = ele.split('=');
			hash[1] = (hash[1].indexOf('#') !== -1) ? hash[1].split('#')[0] : hash[1];
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		});
		return vars;
	},
	accordion() {
		const details = document.querySelectorAll('.js-accordion');

		details.forEach(ele => {
			const summary = ele.querySelector('summary');
			const wrapper = ele.querySelector('.mod-accordion-wrapper');
			const plus = ele.querySelector('.mod-accordion-plus');
			if (!summary || !wrapper) return;

			// 進行中の wrapper アニメ（連打時の競合・fill 累積を防ぐためトラッキング）
			let currentAnim = null;

			// wrapper の初期スタイル設定
			wrapper.style.overflow = 'hidden';

			summary.addEventListener('click', e => {
				e.preventDefault();

				// 前回アニメ（fill: forwards で状態保持中）を終了させる
				// cancel すると effect 消失で inline 値に戻ってしまうため、
				// 先に現在の visible 高さ／opacity を inline 固定してから cancel する
				if (currentAnim) {
					const visibleHeight = wrapper.getBoundingClientRect().height;
					const visibleOpacity = getComputedStyle(wrapper).opacity;
					wrapper.style.height = visibleHeight + 'px';
					wrapper.style.opacity = visibleOpacity;
					currentAnim.cancel();
					currentAnim = null;
				}

				if (ele.open) {
					// 閉じる処理：現在の表示高さ（サブピクセル精度）を起点にアニメーション
					const currentHeight = wrapper.getBoundingClientRect().height;
					wrapper.style.height = currentHeight + 'px';

					// 次のフレームでアニメーション開始（高さの設定を反映させるため）
					requestAnimationFrame(() => {
						const close = wrapper.animate(
							{
								opacity: [1, 0],
								height: [currentHeight + 'px', '0px'],
							},
							{
								duration: 300,
								easing: 'ease',
								fill: 'forwards',
							}
						);
						currentAnim = close;
						if (plus) {
							plus.animate(
								{ rotate: ['90deg', '0deg'] },
								{
									duration: 300,
									pseudoElement: "::after",
									easing: 'ease',
									fill: 'forwards',
								}
							);
						}
						close.onfinish = () => {
							// fill: forwards で 0px に固定したまま残す（details は閉じるので visible 影響なし）
							// 累積防止は次クリック時の cancel で実施
							ele.removeAttribute('open');
						};
					});
				} else {
					// 開く処理
					ele.setAttribute('open', 'true');

					// 前回の inline style をクリアしてからサブピクセル精度で実高さを計測
					wrapper.style.height = '';
					wrapper.style.opacity = '';
					const targetHeight = wrapper.getBoundingClientRect().height;
					wrapper.style.height = '0px';
					wrapper.style.opacity = '0';

					// 次のフレームでアニメーション開始
					requestAnimationFrame(() => {
						const open = wrapper.animate(
							{
								opacity: [0, 1],
								height: ['0px', targetHeight + 'px'],
							},
							{
								duration: 300,
								easing: 'ease',
								fill: 'forwards',
							}
						);
						currentAnim = open;
						if (plus) {
							plus.animate(
								{ rotate: ['0deg', '90deg'] },
								{
									duration: 300,
									pseudoElement: "::after",
									easing: 'ease',
									fill: 'forwards',
								}
							);
						}
						// 完了時にアニメ effect を解除し inline 高さもクリア。
						// fill:forwards で高さを固定したままにすると、後でブラウザ幅が
						// 変わってもアコーディオン内コンテンツの折返しに追従できず
						// 「途中で切れる」現象が発生するため、開き切ったあとは CSS の
						// 自然高さ（auto）に委ねる。
						open.onfinish = () => {
							open.cancel();
							wrapper.style.height = '';
							wrapper.style.opacity = '';
							currentAnim = null;
						};
					});
				}
			});
		});
	},
	tabSwitch() {
		let $tab = document.querySelectorAll('.js-tab');
		let $content = document.querySelectorAll('.js-tab-content');
		if ($tab.length) {
			// ハッシュタグで絞り込み
			if (location.hash) {
				let hash = location.hash.split('#')[1];
				$tab.forEach(ele => {
					ele.classList.remove(a);
					if (ele.getAttribute('data-target').match(hash)) {
						ele.classList.remove(a);
					}
				});
				$content.forEach(ele => {
					ele.classList.remove(a);
					ele.classList.remove(v);
					if (ele.getAttribute('data-target').match(hash)) {
						$(ele).addClass(a);
						setTimeout(() => { ele.classList.add(v); }, 200);
					}
				});
			}

			$tab.forEach(ele => {
				ele.addEventListener('click', () => {
					$tab.forEach(ele2 => { ele2.classList.remove(a); })
					ele.classList.add(a);
					$content.forEach(ele => {
						ele.classList.remove(a);
						ele.classList.remove(v);
					});

					let $target;
					let target = ele.getAttribute('data-target');
					if (target === 'all') {
						$target = $content;
					} else {
						$target = document.querySelectorAll('[data-target="' + target + '"]');
					}
					$target.forEach(ele => {
						ele.classList.add(a);
						setTimeout(() => { ele.classList.add(v); }, 200);
					});
				});
			});
		}
	},
	easeScroll() {
		const scrollToObject = (_self) => {
			let hash = _self.currentTarget.href.split('#')[1];
			let pos = hash === 'pagetop' ? 0 : document.getElementById(hash).getBoundingClientRect().top;
			let offset = hash === 'pagetop' ? 0 : window.scrollY;
			pos += offset;

			if (hash !== 'pagetop') {
				if (FUNCTIONS.va.window.width <= FUNCTIONS.va.device.desktop) {
					pos = pos - FUNCTIONS.va.header.sp;
				} else {
					pos = pos - FUNCTIONS.va.header.desktop;
				}
			}
			window.scrollTo({ top: pos, behavior: 'smooth' });
		}
		// フォーカス用関数
		const scrollFocus = (_hash) => {
			let hash = _hash;
			if (hash !== 'pagetop') {
				const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
				const focusableElements = Array.from(
					document.getElementById(hash).querySelectorAll(focusableElementsSelector)
				);
				if (focusableElements.length) {
					focusableElements[0].focus({ preventScroll: true });
				}
			}
		};
		// スクロール完了後に実行する関数
		let scrollResolveTimeout;
		const waitForScrollComplete = (_hash) => {
			return new Promise((resolve) => {
				const scrollTimeout = setTimeout(() => {
					resolve(true);
				}, 100);
				const scrollTimeoutEvent = addEventListener('scroll', function fn(e) {
					clearTimeout(scrollTimeout);
					clearTimeout(scrollResolveTimeout);
					scrollResolveTimeout = setTimeout(function () {
						scrollFocus(_hash);
						removeEventListener('scroll', fn);
						resolve(true);
					}, 100);
				});
			});
		};
		document.querySelectorAll('a[rel="scroll"]').forEach((ele) => {
			ele.addEventListener('click', async (e) => {
				e.preventDefault();
				if (/#/.test(e.currentTarget.href)) {
					scrollToObject(e);
					let hash = e.currentTarget.href.split('#')[1];
					await waitForScrollComplete(hash);
					return false;
				}
			});
		});
	},
	easeScrollHash() {
		const hash = location.hash;
		if (hash) {
			// フォーカス用関数
			const scrollFocus = (_hash) => {
				let hash = _hash;
				if (hash !== 'pagetop') {
					const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
					const focusableElements = Array.from(
						document.getElementById(hash).querySelectorAll(focusableElementsSelector)
					);
					if (focusableElements.length) {
						focusableElements[0].focus();
					}
				}
			}
			// スクロール完了後に実行する関数
			let scrollResolveTimeout;
			const waitForScrollComplete = (_hash) => {
				return new Promise((resolve) => {
					const scrollTimeout = setTimeout(() => {
						resolve(true);
					}, 100);
					const scrollTimeoutEvent = addEventListener('scroll', function fn(e) {
						clearTimeout(scrollTimeout);
						clearTimeout(scrollResolveTimeout);
						scrollResolveTimeout = setTimeout(function () {
							scrollFocus(_hash);
							removeEventListener('scroll', fn);
							resolve(true);
						}, 100);
					});
				});
			}
			window.addEventListener('load', async () => {
				const targetEl = document.getElementById(hash.split('#')[1]);
				// ハッシュに対応する要素が無い場合は何もしない
				if (!targetEl) return;

				// Webフォント（display=swap）の差し替えでアンカー上方のテキスト高さが
				// 変化し着地位置がずれるため、フォント読み込み完了を待ってから位置を確定する
				if (document.fonts && document.fonts.ready) {
					await document.fonts.ready;
				}
				// レイアウト確定を待つ（2フレーム）
				await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));

				let pos = targetEl.getBoundingClientRect().top + window.scrollY;

				if (FUNCTIONS.va.window.width <= FUNCTIONS.va.device.desktop) {
					pos -= FUNCTIONS.va.header.sp;
				} else {
					pos -= FUNCTIONS.va.header.desktop;
				}
				window.scrollTo({ top: pos, behavior: 'smooth' });
				await waitForScrollComplete(hash);
			});
		}
	},
	pageTop() {
		let $pagetop = document.querySelector('.footer-pagetop');

		if ($pagetop) {
			window.addEventListener('scroll', (e) => {
				if (window.scrollY > '100') {
					$pagetop.classList.add(v);
				} else {
					$pagetop.classList.remove(v);
				}
			});
		}
	},
	setModal() {
		const createModal = (_appendHTML, _target) => {
			const $container = document.createElement('div');
			$container.className = 'mod-modal-overlay';
			$container.innerHTML = _appendHTML;
			document.body.appendChild($container);

			$container.classList.add(a);
			setTimeout(() => {
				$container.classList.add(v);
				document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach((ele) => {
					ele.addEventListener('click', (e) => {
						$container.classList.remove(v);
						setTimeout(() => {
							$container.classList.remove(a);
							$container.remove();
							_target.focus();
						}, 400);
					});
				});
				window.addEventListener("keydown", function (event) {
					if (document.querySelectorAll('.mod-modal-overlay').length) {
						// タブキーが押された時
						if (event.key === "Tab") {
							event.preventDefault();
							// モーダル要素内のフォーカス可能な要素の一覧を取得
							const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
							const focusableElements = Array.from(
								document.querySelector('.mod-modal-overlay').querySelectorAll(focusableElementsSelector)
							);
							// 現在のフォーカス位置を取得
							const focusedItemIndex = focusableElements.indexOf(document.activeElement);
							// shiftキーと同時に押されてた場合
							if (event.shiftKey) {
								if (focusedItemIndex === 0) {
									// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
									focusableElements[focusableElements.length - 1].focus();
								} else {
									// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
									focusableElements[focusedItemIndex - 1].focus();
								}
							} else {
								if (focusedItemIndex === focusableElements.length - 1) {
									// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
									focusableElements[0].focus();
								} else {
									// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
									focusableElements[focusedItemIndex + 1].focus();
								}
							}
						}
						// ESCキーが押された時
						if (event.key === "Escape") {
							event.preventDefault();
							$container.classList.remove(v);
							setTimeout(() => {
								$container.classList.remove(a);
								$container.remove();
								_target.focus();
							}, 400);
						}
					}
				});
			});
		};
		document.querySelectorAll('.mod-modal').forEach((ele) => {
			ele.addEventListener('click', (e) => {
				let targetKey = e.currentTarget.getAttribute('data-target');
				let $content = document.querySelector(`.mod-modalContent[data-target="${targetKey}"]`);
				if ($content) {
					let closeButton = document.createElement('button');
					closeButton.setAttribute('type', 'button');
					closeButton.className = 'mod-modal-closeBtn';
					closeButton.setAttribute('aria-label', 'close');
					closeButton.innerHTML = '<span aria-hidden="true"></span>';

					$content.appendChild(closeButton);

					let closeArea = document.createElement('div');
					closeArea.className = 'mod-modal-closeArea';
					let containerDiv = document.createElement('div');
					containerDiv.appendChild(closeArea);
					containerDiv.appendChild($content.cloneNode(true));

					createModal(containerDiv.innerHTML, e.currentTarget);
				}
				return false;
			});
		});

		// 画像1個だけのモーダル
		document.querySelectorAll('.mod-modalImg').forEach((ele) => {
			ele.addEventListener('click', (e) => {
				let appendHTML = `<div class="mod-modal-closeArea"></div>
					<button type="button" class="mod-modal-closeBtn" aria-label="close"><span aria-hidden="true"></span></button>
					${e.currentTarget.querySelector('img').outerHTML}`;
				createModal(appendHTML, e.currentTarget);
				return false;
			});
		});
	},
	matchHeight() {
		const $elements = document.querySelectorAll('[data-mh]');
		const groups = new Map();

		$elements.forEach(ele => { ele.style.height = 'auto'; }); // 初期化

		$elements.forEach(ele => {
			const attributeName = ele.getAttribute('data-mh');
			if (!groups.has(attributeName)) {
				groups.set(attributeName, []);
			}
			groups.get(attributeName).push(ele);
		});
		groups.forEach(group => {
			const attributeGroups = new Map();
			group.forEach(ele => {
				const attributeName = ele.getAttribute('data-mh');
				const topPosition = ele.getBoundingClientRect().top;
				const key = attributeName + '_' + topPosition;
				if (!attributeGroups.has(key)) {
					attributeGroups.set(key, []);
				}
				attributeGroups.get(key).push(ele);
			});
			attributeGroups.forEach((item) => {
				const maxHeight = Math.max(...item.map(ele => ele.offsetHeight));
				item.forEach((ele2) => {
					ele2.style.height = `${maxHeight}px`;
				});
			});
		});
	},
	inViewAnimation() {
		const target = document.querySelectorAll('.js-fade');
		const options = {
			root: null,
			rootMargin: '-30% 0px',
			threshold: 0
		};
		const callback = (entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add(v);
				}
			});
		};
		const observer = new IntersectionObserver(callback, options);

		target.forEach(ele => {
			observer.observe(ele);
		});
	},
	listStartOffset() {
		// ul.ul-star_num / ul.ul-star_en_num / ul.ul-paren に start="N" が指定されている場合、
		// CSS 変数 --list-start を (N - 1) に設定し、counter-reset 経由で開始番号を制御する
		const lists = document.querySelectorAll(
			'ul.ul-star_num[start], ul.ul-star_en_num[start], ul.ul-paren[start]'
		);
		lists.forEach(function (list) {
			const start = parseInt(list.getAttribute('start'), 10);
			if (!isNaN(start) && start > 0) {
				list.style.setProperty('--list-start', start - 1);
			}
		});
	},
	fileSize() {
		const bytesToSize = (bytes) => {
			var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
			if (bytes === 0) {
				return 'n/a';
			}
			var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
			if (i === 0) {
				return bytes + ' ' + sizes[i];
			}
			return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
		}
		if (document.querySelectorAll('.js-fileSize').length) {
			document.querySelectorAll('.js-fileSize').forEach(function (pdfElement) {
				pdfElement.textContent = bytesToSize(pdfElement.textContent);
			});
		}
	},
	removeElmIfEmpty() {
		// ＜ルート設定対応＞要素が空だったら削除
		const $eleList = document.querySelectorAll('.js-checkEmptyElm');
		$eleList.forEach(ele => {
			if (!ele.textContent.length) {
				ele.remove();
			}
		});
	},
	removeBlockIfListEmpty() {
		// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
		const $eleList = document.querySelectorAll('.js-checkEmptyList');
		if ($eleList) {
			$eleList.forEach(ele => {
				if (!ele.getElementsByTagName('li').length) {
					ele.closest('.js-checkEmptyList-wrap').remove();
				}
			});
		}
	},
	URLcurrent() {
		if (document.querySelector('.js-current')) {
			document.querySelectorAll('.js-current').forEach(item1 => {
				// 各要素の href を取得し、現在のページのURLに基づいた絶対パスに変換
				const linkPath = new URL(item1.getAttribute('href'), location.origin).pathname.replace(/index\.html$/, '');
				const currentPath = location.pathname.replace(/index\.html$/, '');
				// 現在のページのパスがリンクのパスで始まる場合、is-activeを追加
				if (currentPath == linkPath) {
					item1.classList.add(a);
				}
			});
		}
	},
	setNavCurrent() {
		// 現在のURLのカテゴリディレクトリを取得
		// 日本語: /aboutus/growth.html → /aboutus/
		// 英語  : /english/aboutus/growth.html → /english/aboutus/
		const currentPath = location.pathname.replace(/\/index\.html$/, '/');
		const segments = currentPath.split('/').filter(Boolean);
		if (!segments.length) return; // トップページは何もしない

		const getTopKey = (segs) => {
			if (segs[0] === 'english') {
				if (segs.length < 2) return null; // /english/ トップは対象外
				return '/english/' + segs[1] + '/';
			}
			return '/' + segs[0] + '/';
		};

		const currentTop = getTopKey(segments);
		if (!currentTop) return;

		document.querySelectorAll('.header-main .header-main__link').forEach(link => {
			const href = link.getAttribute('href');
			if (!href) return;
			const hrefSegments = href.split('/').filter(Boolean);
			if (!hrefSegments.length) return;
			const linkTop = getTopKey(hrefSegments);
			if (linkTop && currentTop === linkTop) {
				link.classList.add('is-current');
			}
		});
	},
	setLangSwitch() {
		// ヘッダーの JP/EN 言語切替リンクを現在ページの等価パスに動的設定
		// 日本語: /ir/library.html ⇄ 英語: /english/ir/library.html
		// 反対言語ページが存在しない場合は言語トップ（/ または /english/）へフォールバック
		const currentPath = location.pathname;
		const isEnglish = currentPath.startsWith('/english/');

		// 等価パス算出（hash・query は意図的に破棄）
		const jpPath = isEnglish
			? (currentPath.replace(/^\/english/, '') || '/')
			: currentPath;
		const enPath = isEnglish
			? currentPath
			: '/english' + currentPath;

		const langItems = document.querySelectorAll('.header-lang__item');
		if (!langItems.length) return;

		const jpLinks = [];
		const enLinks = [];
		langItems.forEach(link => {
			const label = (link.textContent || '').trim();
			if (label === 'JP') jpLinks.push(link);
			else if (label === 'EN') enLinks.push(link);
		});

		// まず等価パスを設定
		jpLinks.forEach(link => link.setAttribute('href', jpPath));
		enLinks.forEach(link => link.setAttribute('href', enPath));

		// 反対言語ページの存在を HEAD で確認し、無ければ言語トップへフォールバック
		const checkPath = isEnglish ? jpPath : enPath;
		const fallbackLinks = isEnglish ? jpLinks : enLinks;
		const fallbackPath = isEnglish ? '/' : '/english/';

		fetch(checkPath, { method: 'HEAD' })
			.then(res => {
				if (!res.ok) {
					fallbackLinks.forEach(link => link.setAttribute('href', fallbackPath));
				}
			})
			.catch(() => {
				fallbackLinks.forEach(link => link.setAttribute('href', fallbackPath));
			});
	},
	pcHeaderMegamenu() {
		// if (document.querySelectorAll('.js-header-nav-mega').length) {
		// 	const $header = document.querySelector('.header');
		// 	const $megabtn = document.querySelectorAll('.js-header-nav-mega-btn');
		// 	const $megamenu = document.querySelectorAll('.js-header-nav-mega-contents');
		// 	const closeAllMegaMenus = () => {
		// 		$header.classList.remove(a);
		// 		$megabtn.forEach(btn => {
		// 			btn.classList.remove(a);
		// 			if (btn.nextElementSibling) {
		// 				btn.nextElementSibling.classList.remove(a);
		// 			}
		// 		});
		// 	};
		// 	// メガメニューボタンのクリックイベント処理
		// 	$megabtn.forEach(btn => {
		// 		btn.addEventListener('click', (e) => {
		// 			const clickedBtn = e.currentTarget;
		// 			const clickedNav = clickedBtn.nextElementSibling; // 対応する .header-nav-pc
		// 			// 他のメガメニューを閉じる
		// 			$megabtn.forEach(otherBtn => {
		// 				if (otherBtn !== clickedBtn) {
		// 					otherBtn.classList.remove(a);
		// 					if (otherBtn.nextElementSibling) {
		// 						otherBtn.nextElementSibling.classList.remove(a);
		// 					}
		// 				}
		// 			});
		// 			// クリックされたメガメニューの開閉
		// 			if (clickedBtn.classList.contains(a)) {
		// 				$header.classList.remove(a);
		// 				clickedBtn.classList.remove(a);
		// 				// clickedNavが存在することを確認してから操作
		// 				if (clickedNav) {
		// 					clickedNav.classList.remove(a);
		// 				}
		// 			} else {
		// 				$header.classList.add(a);
		// 				clickedBtn.classList.add(a);
		// 				if (clickedNav) {
		// 					clickedNav.classList.add(a);
		// 				}
		// 			}
		// 		});
		// 	});
		// 	// メガメニュー外のクリックで閉じる
		// 	document.addEventListener("click", (event) => {
		// 		const target = event.target;
		// 		const isClickInsideNav = [...$megamenu]
		// 			.some(el => el.contains(target));
		// 		const isClickOnButton = [...$megabtn]
		// 			.some(btn => btn.contains(target));

		// 		if (!isClickInsideNav && !isClickOnButton && $header.classList.contains(a)) {
		// 			closeAllMegaMenus();
		// 		}
		// 	});
		// 	// フォーカスが外れた時のメニュー制御を追加
		// 	$megabtn.forEach(btn => {
		// 		const menu = btn.nextElementSibling;
		// 		if (menu) {
		// 			// フォーカスが .header-nav-pc 内にあるかチェックする関数
		// 			const isInsideAnyHeaderNav = (element) => {
		// 				return Array.from($megamenu).some(headerNav => headerNav.contains(element));
		// 			};
		// 			// フォーカスが外れた時にメニューを閉じる
		// 			menu.addEventListener('focusout', () => {
		// 				setTimeout(() => {
		// 					const focusedElement = document.activeElement;
		// 					const isInsideNav = menu.contains(focusedElement);
		// 					const isInsideButton = btn.contains(focusedElement);
		// 					const isInsideHeaderNav = isInsideAnyHeaderNav(focusedElement);
		// 					// .header-nav-pc 内にフォーカスがない場合に閉じる
		// 					if (!isInsideNav && !isInsideButton && !isInsideHeaderNav) {
		// 						closeAllMegaMenus();
		// 					}
		// 				}, 0);
		// 			});
		// 			// TabキーまたはShift+Tabで移動した際にメニューを閉じる
		// 			document.addEventListener('keydown', (e) => {
		// 				if (e.key === 'Tab') {
		// 					setTimeout(() => {
		// 						const focusedElement = document.activeElement;
		// 						const isInsideNav = menu.contains(focusedElement);
		// 						const isInsideButton = btn.contains(focusedElement);
		// 						const isInsideHeaderNav = isInsideAnyHeaderNav(focusedElement);
		// 						// .header-nav-pc 内にフォーカスがない場合に閉じる
		// 						if (!isInsideNav && !isInsideButton && !isInsideHeaderNav) {
		// 							closeAllMegaMenus();
		// 						}
		// 					}, 0);
		// 				}
		// 			});
		// 		}
		// 	});
		// 	// ESCキーでメガメニューを閉じる
		// 	window.addEventListener("keydown", function (event) {
		// 		if ($header.classList.contains(a)) {
		// 			if (event.key === "Escape") {
		// 				event.preventDefault();
		// 				closeAllMegaMenus();
		// 			}
		// 		}
		// 	});
		// }
		var header = document.getElementById('siteHeader');
		console.log("header:", header);
		if (!header) return;

		/* ---- メガメニュー（PC） ---- */
		var megaWrap = document.getElementById('headerMega');
		var mainLinks = header.querySelectorAll('[data-mega]');
		var panels = megaWrap ? megaWrap.querySelectorAll('.header-mega__panel') : [];
		var closeBtn = megaWrap ? megaWrap.querySelector('.header-mega__close') : null;
		var overlay = document.querySelector('.header-overlay');

		function openMega(key) {
			if (!megaWrap) return;
			// 検索オーバーレイが開いていたら閉じる（メガメニューと重ならないように）
			// 相互排他切替時はオーバーレイを維持して連続フェードのバグを防ぐ
			if (searchWrap && searchWrap.classList.contains('is-active')) {
				closeSearch(true);
				if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
			}
			panels.forEach(function (p) {
				p.classList.remove('is-visible');
				p.classList.remove('is-active');
			});
			mainLinks.forEach(function (l) { l.classList.remove('is-active'); });
			var target = megaWrap.querySelector('[data-panel="' + key + '"]');
			var link = header.querySelector('[data-mega="' + key + '"]');
			if (target) {
				target.classList.add('is-active');
				setTimeout(function () { target.classList.add('is-visible'); }, 10);
				megaWrap.classList.add('is-active');
				setTimeout(function () { megaWrap.classList.add('is-visible'); }, 10);
				megaWrap.setAttribute('aria-hidden', 'false');
				// メガメニューを開いている間はヘッダーに is-mega-open を付与。
				// 別カテゴリのメニューを開いたとき、元ページのカレント表示（色・下線）が
				// 残って二重に強調され混乱する問題に対応（CSS 側で is-active 以外の
				// is-current を抑制する）
				header.classList.add('is-mega-open');
				if (link) link.classList.add('is-active');
				if (overlay) {
					overlay.classList.add('is-active');
					setTimeout(function () { overlay.classList.add('is-visible'); }, 10);
				}
			}
		}
		function closeMega(keepOverlay) {
			if (!megaWrap) return;
			mainLinks.forEach(function (l) { l.classList.remove('is-active'); });
			// メガメニューを閉じたらカレント表示（色・下線）を元に戻す
			header.classList.remove('is-mega-open');
			megaWrap.classList.remove('is-visible');
			panels.forEach(function (p) { p.classList.remove('is-visible'); });
			megaWrap.setAttribute('aria-hidden', 'true');
			setTimeout(function () {
				megaWrap.classList.remove('is-active');
				panels.forEach(function (p) { p.classList.remove('is-active'); });
			}, 300);
			if (overlay && !keepOverlay) {
				overlay.classList.remove('is-visible');
				setTimeout(function () { overlay.classList.remove('is-active'); }, 300);
			}
		}

		mainLinks.forEach(function (link) {
			link.addEventListener('click', function (e) {
				e.preventDefault();
				var key = this.getAttribute('data-mega');
				var target = megaWrap ? megaWrap.querySelector('[data-panel="' + key + '"]') : null;
				if (target && target.classList.contains('is-active')) {
					closeMega();
				} else {
					openMega(key);
				}
			});
		});

		if (closeBtn) closeBtn.addEventListener('click', function () { closeMega(); });

		/* メガメニュー外クリックで閉じる */
		document.addEventListener('click', function (e) {
			if (!megaWrap || !megaWrap.classList.contains('is-active')) return;
			if (e.target.closest('.header-mega') || e.target.closest('[data-mega]')) return;
			// 検索 UI へのクリックは openSearch 側で相互排他処理するためスキップ
			if (e.target.closest('.header-search') || e.target.closest('.header-search-toggle')) return;
			closeMega();
		});

		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape') {
				closeMega();
				closeSearch();
				closeSPMenu();
			}
		});

		/* ---- 検索 ---- */
		var searchWrap = document.getElementById('headerSearch');
		var searchToggle = header.querySelector('.header-search-toggle');
		var searchClose = searchWrap ? searchWrap.querySelector('.header-search__close') : null;

		function openSearch() {
			if (!searchWrap) return;
			// メガメニューが開いていたら閉じる（相互排他）
			// 相互排他切替時はオーバーレイを維持して連続フェードのバグを防ぐ
			if (megaWrap && megaWrap.classList.contains('is-active')) {
				closeMega(true);
			}
			searchWrap.classList.add('is-active');
			setTimeout(function () { searchWrap.classList.add('is-visible'); }, 10);
			searchWrap.setAttribute('aria-hidden', 'false');
			if (overlay) {
				overlay.classList.add('is-active');
				setTimeout(function () { overlay.classList.add('is-visible'); }, 10);
			}
			var input = searchWrap.querySelector('input');
			if (input) input.focus();
		}
		function closeSearch(keepOverlay) {
			if (!searchWrap) return;
			searchWrap.classList.remove('is-visible');
			setTimeout(function () { searchWrap.classList.remove('is-active'); }, 300);
			searchWrap.setAttribute('aria-hidden', 'true');
			if (overlay && !keepOverlay) {
				overlay.classList.remove('is-visible');
				setTimeout(function () { overlay.classList.remove('is-active'); }, 300);
			}
		}
		if (searchToggle) searchToggle.addEventListener('click', function () {
			var expanded = this.getAttribute('aria-expanded') === 'true';
			if (expanded) { closeSearch(); } else { openSearch(); }
			this.setAttribute('aria-expanded', expanded ? 'false' : 'true');
		});
		if (searchClose) searchClose.addEventListener('click', function () {
			closeSearch();
			if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
		});

		/* 検索外クリックで閉じる */
		document.addEventListener('click', function (e) {
			if (!searchWrap || !searchWrap.classList.contains('is-active')) return;
			if (e.target.closest('.header-search') || e.target.closest('.header-search-toggle')) return;
			// メガメニュー UI へのクリックは openMega 側で相互排他処理するためスキップ
			if (e.target.closest('.header-mega') || e.target.closest('[data-mega]')) return;
			closeSearch();
			if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
		});

		/* ---- SP メニュー ---- */
		var spMenu = document.getElementById('spMenu');
		var spToggle = document.getElementById('spMenuToggle');
		var spClose = spMenu ? spMenu.querySelector('.header-sp__close') : null;

		function openSPMenu() {
			if (!spMenu) return;
			spMenu.classList.add('is-active');
			setTimeout(function () { spMenu.classList.add('is-visible'); }, 10);
			spMenu.setAttribute('aria-hidden', 'false');
			document.body.style.overflow = 'hidden';
			if (spToggle) spToggle.setAttribute('aria-expanded', 'true');
		}
		function closeSPMenu() {
			if (!spMenu) return;
			spMenu.classList.remove('is-visible');
			setTimeout(function () { spMenu.classList.remove('is-active'); }, 300);
			spMenu.setAttribute('aria-hidden', 'true');
			document.body.style.overflow = '';
			if (spToggle) spToggle.setAttribute('aria-expanded', 'false');
		}
		if (spToggle) spToggle.addEventListener('click', openSPMenu);
		if (spClose) spClose.addEventListener('click', closeSPMenu);
	},
	spHeaderHamburger() {
		if (document.querySelectorAll('.js-header-hamburger').length) {
			const $header = document.querySelector('.header');
			const $hamburger = document.querySelector('.js-header-hamburger');
			const $nav = document.querySelector('.js-header-nav-sp');
			const $container = document.querySelector('.container');
			let scrollTopNow;
			const fixedOnContainer = () => {
				scrollTopNow = window.scrollY;
				$container.style.position = 'fixed';
				$container.style.width = '100%';
				$container.style.top = -1 * scrollTopNow;
				$container.style.left = 0;
				$container.querySelector('.contents').style.opacity = '0';
			};
			const fixedOffContainer = () => {
				$container.style.position = 'static';
				$container.querySelector('.contents').style.opacity = '1';
				window.scrollTo({ top: scrollTopNow });
			};
			$hamburger.addEventListener('click', (e) => {
				if ($nav.classList.contains(a)) {
					$nav.classList.remove(a);
					$hamburger.classList.remove(a);
					$hamburger.ariaLabel = 'open'
					fixedOffContainer();
				} else {
					fixedOnContainer();
					$nav.classList.add(a);
					$hamburger.classList.add(a);
					$hamburger.ariaLabel = 'close'
				}
			});
			window.addEventListener("keydown", function (event) {
				if ($nav.classList.contains(a)) {
					// タブキーが押された時
					if (event.key === "Tab") {
						event.preventDefault();
						// ヘッダー内のフォーカス可能な要素を取得（display: none の要素を除外）
						const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
						let focusableElements = Array.from($header.querySelectorAll(focusableElementsSelector))
							.filter(el => el.offsetParent !== null); // 非表示要素を除外
						if (focusableElements.length === 0) return;
						// 現在のフォーカス位置を取得
						const focusedItemIndex = focusableElements.indexOf(document.activeElement);
						console.log(focusedItemIndex, focusableElements);
						// shiftキーと同時に押されてた場合
						if (event.shiftKey) {
							if (focusedItemIndex === 0) {
								// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
								focusableElements[focusableElements.length - 1].focus();
							} else {
								// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
								focusableElements[focusedItemIndex - 1].focus();
							}
						} else {
							if (focusedItemIndex === focusableElements.length - 1) {
								// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
								focusableElements[0].focus();
							} else {
								// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
								focusableElements[focusedItemIndex + 1].focus();
							}
						}
					}
					// ESCキーが押された時
					if (event.key === "Escape") {
						event.preventDefault();
						$nav.classList.remove(a);
						$hamburger.classList.remove(a);
						$hamburger.ariaLabel = 'close'
						fixedOffContainer();
						$hamburger.focus({ preventScroll: true });
					}
				}
			});
		}
	},
	carousel() {
		document.querySelectorAll('.js-carousel').forEach(el => {
			const track = el.querySelector('.mod-carousel-track');
			const slides = el.querySelectorAll('.mod-carousel-slide');
			if (!track || slides.length < 2) return;

			let current = 0;
			const total = slides.length;
			const interval = parseInt(el.dataset.interval || '5000', 10);
			let timer = null;
			let paused = false;
			let progress = 0;
			let progressTimer = null;

			const numEl = el.querySelector('.mod-carousel-num');
			const progressBar = el.querySelector('.mod-carousel-progress-bar');
			const pauseBtn = el.querySelector('.mod-carousel-pause');
			const dots = el.querySelectorAll('.mod-carousel-dot');
			const isFade = el.classList.contains('__fade');
			const isEnglish = window.location.pathname.startsWith('/english/');
			const label = {
				play: isEnglish ? 'Play slide' : 'スライド再生',
				pause: isEnglish ? 'Pause slide' : 'スライド一時停止'
			};

			function update() {
				if (isFade) {
					slides.forEach((s, i) => { s.classList.toggle('is-active', i === current); });
				} else {
					track.style.transform = 'translateX(-' + (current * 100) + '%)';
				}
				if (numEl) numEl.textContent = String(current + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
				dots.forEach((d, i) => { d.classList.toggle('is-active', i === current); });
			}

			function startProgress() {
				progress = 0;
				if (progressBar) progressBar.style.width = '0%';
				clearInterval(progressTimer);
				progressTimer = setInterval(() => {
					progress += 100 / (interval / 50);
					if (progressBar) progressBar.style.width = Math.min(progress, 100) + '%';
				}, 50);
			}

			function goTo(idx) {
				current = (idx + total) % total;
				update();
				resetAutoplay();
			}

			function next() { goTo(current + 1); }
			function prev() { goTo(current - 1); }

			function resetAutoplay() {
				clearTimeout(timer);
				if (!paused) {
					startProgress();
					timer = setTimeout(next, interval);
				}
			}

			// ボタン
			const prevBtn = el.querySelector('.mod-carousel-prev');
			const nextBtn = el.querySelector('.mod-carousel-next');
			if (prevBtn) prevBtn.addEventListener('click', prev);
			if (nextBtn) nextBtn.addEventListener('click', next);

			// ドット
			dots.forEach((d, i) => { d.addEventListener('click', () => goTo(i)); });

			// 一時停止
			if (pauseBtn) {
				pauseBtn.addEventListener('click', () => {
					paused = !paused;
					pauseBtn.setAttribute('aria-label', paused ? label.play : label.pause);
					const svg = pauseBtn.querySelector('use');
					if (svg) svg.setAttribute('href', paused ? '/cnt_common/svg/sprite.svg#play_circle' : '/cnt_common/svg/sprite.svg#stop');
					if (paused) {
						clearTimeout(timer);
						clearInterval(progressTimer);
					} else {
						resetAutoplay();
					}
				});
			}

			// タッチスワイプ
			let touchStartX = 0;
			let touchEndX = 0;
			el.addEventListener('touchstart', e => { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
			el.addEventListener('touchend', e => {
				touchEndX = e.changedTouches[0].screenX;
				const diff = touchStartX - touchEndX;
				if (Math.abs(diff) > 50) {
					if (diff > 0) next(); else prev();
				}
			});

			// 初期化
			if (isFade) slides[0].classList.add('is-active');
			update();
			resetAutoplay();
		});
	},
	scrollHint() {
		if (document.querySelectorAll('.js-scroll-hint').length) {
			const isEnglish = window.location.pathname.startsWith('/english/');
			new ScrollHint('.js-scroll-hint', {
				i18n: {
					scrollable: isEnglish ? 'Scrollable' : 'スクロールできます'
				}
			});
		}
	},
	localNavLink() {
		const localNavLinks = document.querySelector('.js-LocalNavLinks');
		console.log('Setting active state for local navigation links...');

		if (!localNavLinks) return;

		const currentPath = window.location.pathname;
		const links = localNavLinks.querySelectorAll('a');

		links.forEach(link => {
			const linkPath = new URL(link.href, window.location.origin).pathname;
			if (linkPath === currentPath) {
				link.classList.add(a);
			}
		});
	},
	loadDelayScript() {
		let _this = this;
		_this.accordion();
		_this.tabSwitch();
		_this.carousel();
		_this.easeScroll();
		_this.easeScrollHash();
		_this.pageTop();
		_this.setModal();
		_this.matchHeight();
		_this.inViewAnimation();
		_this.listStartOffset();
		_this.fileSize();
		_this.removeElmIfEmpty();
		_this.removeBlockIfListEmpty();
		_this.URLcurrent();
		_this.setNavCurrent();
		_this.setLangSwitch();
		_this.pcHeaderMegamenu();
		_this.spHeaderHamburger();
		_this.scrollHint();
		_this.localNavLink();

		let resizeTime = 0;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTime);
			resizeTime = setTimeout(() => { _this.matchHeight(); }, 300);
		});
	}
};

document.addEventListener('DOMContentLoaded', () => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
